<template>
  <div class="more-markets">
    <div v-if="listColumns1.length > 0" class="more-markets__ball-drawn">
      <div
          v-for="(market, index) in listColumns1"
          :key="index"
      >
        <div class="more-markets__ball-title-common">
          {{ market.name }}
        </div>
        <div
            v-for="(item, i) in market.markets"
            :key="i"
        >
          <div v-if="item.select_numbers === 'no'">
            <BallToggle
                :title="item.description"
                :data=dataUnderOver
                :data-component="item"
                @toggle="item.isActiveToggle = !item.isActiveToggle"
                :isShow="item.isActiveToggle"
                @clickItem="handleClickItem(i, $event)"
            />
          </div>
          <div v-else-if="item.select_numbers === 'yes'">
            <BallToggle
                :title="item.description"
                :numbers="numbersBonusBall"
                :data=BallNumbers
                @handleAddLine="$emit('handleAddLine')"
                @handleChosenItem="handleChosenNumberBonusBall($event, item.outcomes)"
                @toggle="item.isActiveToggle = !item.isActiveToggle"
                :isShow="item.isActiveToggle"
            />
          </div>
<!--          <BallToggle-->
<!--              :title="item.description"-->
<!--              :data=dataUnderOver-->
<!--              :data-component="item"-->
<!--              @toggle="item.isActive = !item.isActive"-->
<!--              :isShow="item.isActive"-->
<!--              @clickItem="handleClickItem"-->
<!--          />-->
        </div>
      </div>
    </div>
    <div v-if="listColumns2.length > 0" class="more-markets__bonus-ball">
      <div v-for="(market, index) in listColumns2"
           :key="index">
        <div class="more-markets__ball-title-common">
          {{ market.name }}
        </div>
        <div
            v-for="(item, i) in market.markets"
            :key="i"
        >
          <div v-if="item.select_numbers === 'no'">
            <BallToggle
                :title="item.description"
                :data=dataUnderOver
                :data-component="item"
                @toggle="item.isActiveToggle = !item.isActiveToggle"
                :isShow="item.isActiveToggle"
                @clickItem="handleClickItem(i, $event)"
            />
          </div>
          <div v-else-if="item.select_numbers === 'yes'">
            <div v-for="(number, key) in numbersBonusBall" :key="key">
              <BallToggle
                  v-if="number.key === item.keyNumbers"
                  :title="item.description"
                  :numbers="number.numbers"
                  :data=BallNumbers
                  @handleAddLine="$emit('handleAddLine')"
                  @handleChosenItem="handleChosenNumberBonusBall($event, item.outcomes)"
                  @toggle="item.isActiveToggle = !item.isActiveToggle"
                  :isShow="item.isActiveToggle"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <BallChosen
      :title="'YOUR CHOSEN LINES ARE'"
      :dataChosen="listChosen"
      @delete-item="handleConfirmDeleteItemChosen"
      @clickViewBetslip="$emit('clickViewBetslip')"
      @clickAddBetslip="$emit('clickAddBetslip')"
    />
  </div>
</template>
<script>
import BallNumbers from '@/components/common/ball/ball-numbers.vue';
import BallToggle from '@/components/common/ball/ball-toggle.vue';
import BallChosen from '@/components/common/ball/ball-chosen.vue';
import BallChosenUnderOver from '@/components/common/ball/ball-chosen-under-over.vue';
export default {
  props: {
    dataMoreMarkets: {
      type: Array,
      default: () => []
    },
    numbersBonusBall: {
      type: Array,
      default: () => []
    },
    numbersBallNotToFall: {
      type: Array,
      default: () => []
    },
    listChosen: {
      type: Array,
      default: () => []
    },
    isShowModalConfirmDelete: {
      type: Boolean,
      default: false
    }
  },
  components: {
    BallToggle,
    BallChosen
  },
  data() {
    return {
      listColumns1: [],
      listColumns2: [],
      listOddEven: [],
      listOverUnder: [],
      BallNumbers,
      dataUnderOver: BallChosenUnderOver,
    }
  },
  watch: {
    dataMoreMarkets(val) {
      const n = 2
      const result = [ [], []]

      const wordsPerLine = Math.ceil(val.length / 2)

      for (let line = 0; line < n; line++) {
        for (let i = 0; i < wordsPerLine; i++) {
          const value = val[i + line * wordsPerLine]
          if (!value) continue
          result[line].push(value)
        }
      }
      this.listColumns1 = result[0]
      this.listColumns2 = result[1]
    }
  },
  methods: {
    handleClickItem(value, event) {
      this.$emit('clickItem', {market_id: value, data: event})
    },
    handleConfirmDeleteItemChosen(index) {
      this.$emit('handleConfirmDeleteItemChosen', index)
    },
    handleChosenNumberBonusBall(index, data) {
      this.$emit('handleChosenItem', {index, type: 'bonus', outcome: data})
    }
  }
}
</script>
